// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8C-aw","toggleWrap":"styles_toggleWrap__2iQIS","content":"styles_content__T5bns","selectAreaCode":"styles_selectAreaCode__1wr6j"};